export default "__VITE_ASSET__B30Yx$3y__"